import { render, staticRenderFns } from "./chinese.vue?vue&type=template&id=737d7fd8&"
import script from "./chinese.vue?vue&type=script&lang=js&"
export * from "./chinese.vue?vue&type=script&lang=js&"
import style0 from "./chinese.vue?vue&type=style&index=0&id=737d7fd8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports